import { render } from "./PlanningFormAssigneesComponent.vue?vue&type=template&id=0b04e742"
import script from "./PlanningFormAssigneesComponent.vue?vue&type=script&lang=js"
export * from "./PlanningFormAssigneesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__